import { render } from "./AddOlt.vue?vue&type=template&id=585f0871&scoped=true"
import script from "./AddOlt.vue?vue&type=script&lang=js"
export * from "./AddOlt.vue?vue&type=script&lang=js"

import "./AddOlt.vue?vue&type=style&index=0&id=585f0871&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585f0871"]])

export default __exports__